var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { classify } = require("./lib/helpers");
var d3 = {
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
};

var onWindowLoaded = function() {
  renderCartogram({
    container: '#cartogram',
    data: DATA, 
    type: TYPE
  });

  renderNortheastSquares();
  colorGeoMap(DATA, TYPE);
  renderGeoLabels(DATA, TYPE);

  document.querySelector('.controls').addEventListener('change', toggleMap);

  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => {
      renderCartogram({
        container: '#cartogram',
        data: DATA, 
        type: TYPE
      });
      renderGeoLabels(DATA, TYPE);
      child.sendHeight();
    });
  });
};

var isSmall = window.matchMedia("(max-width: 450px)"),
  isMedium = window.matchMedia("(min-width: 451px) and (max-width: 750px)"),
  isBig = window.matchMedia("(min-width: 751px)");
var domain = Object.keys(LEGEND);
var range = Object.keys(LEGEND).map(d => LEGEND[d].color);
var textColorRange = Object.keys(LEGEND).map(d => LEGEND[d].textColor);
var geoLabelColorExceptions = ["HI", "ME", "NE"];
var colorScale = d3.scaleOrdinal(domain, range);
var textColorScale = d3.scaleOrdinal(domain, textColorRange);
var districts = ["NE-1", "NE-2", "NE-3", "NE-AL-A", "NE-AL-B", "ME-1", "ME-2", "ME-AL-A", "ME-AL-B"];
var northeastStates = ["VT", "NH", "MA", "CT", "RI", "NJ", "DE", "MD", "DC"];
var horizontalStates = ["NE", "ME", "KY", "TN"];
var cartogramEl = d3.select("#cartogram");
var geographicMapEl = d3.select("#geographic-map");
var geographicMapSvg = geographicMapEl.select("svg");

var toggleMap = function(e) {
  var target = e.srcElement.id;

  switch(target) {
    case "geography-mode":
      cartogramEl.classed("active", false);
      geographicMapEl.classed("active", true);
      break;
    case "cartogram-mode":
      cartogramEl.classed("active", true);
      geographicMapEl.classed("active", false);
      break;
  }

  pym.then(child => {
    child.sendHeight();
  });
};

var renderCartogram = function(config) {
  var containerElement = d3.select(config.container);
  containerElement.html('');
  var chartWidth = containerElement.node().offsetWidth,
    chartHeight = chartWidth * 0.68;

  var chartElement = containerElement.append("svg")
    .attr("width", chartWidth)
    .attr("height", chartHeight)
    .attr("viewBox", "0 0 705 475")
    .append("g");

  var scaleFactor = 200;
  var row = 0;
  var colPos = 0;
  chartElement.append("g")
    .attr("class", "squares")
    .selectAll("rect")
    .data(config.data)
    .enter()
    .append("rect")
    .attr("class", d => classify(d.usps))
    .attr("width", d => Math.floor(Math.sqrt(d.electors * scaleFactor)))
    .attr("height", d =>Math.floor(Math.sqrt(d.electors * scaleFactor)))
    .attr("x", d => d.cartoX)
    .attr("y", d => d.cartoY)
    .attr("fill", function(d) {
      // fill black if no data or data doesn't match any of the categories
      if (!d[config.type + "_value"] || !domain.includes(d[config.type + "_value"])) { 
        return "#000"; 
      } else {
        return colorScale(d[config.type + "_value"]); 
      }
    }); 


  // cartogram labels
  var cartoLabels = chartElement.append("g")
    .attr("id", "carto-labels")
    .selectAll("text")
    .data(config.data)
    .enter()
    .append("text")
    .text(d => d.usps)
    .attr("class", d => classify(d.id) + "-label")
    .attr("text-anchor", "middle")
    .attr("fill", d => {
      if (d.usps === "NE" || d.usps === "ME") {
        return "#222222";
      } else {
        return textColorScale(d[config.type + "_value"]);
      }
    })
    .attr("font-size", d => {
      if (isSmall.matches) {
        return d.electors > 3 ? 19 : 15;
      } else if (isMedium.matches) {
        return d.electors > 4 ? 14 : 11;
      } else {
        return d.electors > 4 ? 12 : 10;
      }
    })
    .attr("x", (d, i) => {
      if (d.usps === "NE") {
        return 209;
      } else if (d.usps === "ME") {
        return 660;
      } else {
        var x = d.cartoX;
        var width = Math.floor(Math.sqrt(d.electors * scaleFactor));
        return x + width / 2;
      }
    })
    .attr("y", (d, i) => {
      if (d.usps === "NE") {
        return isSmall.matches ? 228 : 232;
      } else if (d.usps === "ME") {
        return 20;
      } else {
        var y = d.cartoY;
        var height = Math.floor(Math.sqrt(d.electors * scaleFactor));
        return y + height / 2;
      }
    })
    .attr("dx", 0)
    .attr("dy", isMobile.matches ? 6 : -2);

  d3.selectAll(".carto-elector-labels").remove();
  if (!isMobile.matches) {
    cartoLabels.append("tspan") 
      .attr("class", "carto-elector-labels")
      .text(d => {
        if (d.usps === "NE") {
          return "5";
        } else if (d.usps === "ME") {
          return "4";
        } else {
          return d.electors;
        }
      })
      .attr("x", (d, i) => {
        if (d.usps === "NE") {
          return 209;
        } else if (d.usps === "ME") {
          return 660;
        } else {
          var x = d.cartoX;
          var width = Math.floor(Math.sqrt(d.electors * scaleFactor));
          return x + width / 2;
        }
      })
      .attr("y", (d, i) => {
        if (d.usps === "NE") {
          return 240;
        } else if (d.usps === "ME") {
          return 28;
        } else {
          var y = d.cartoY;
          var height = Math.floor(Math.sqrt(d.electors * scaleFactor));
          var offset = d.electors > 4 ? 11 : 8;
          return y + height / 2 + offset;
        }
      });
  }
};

var renderNortheastSquares = function() {  
  var northeastStateGroups = geographicMapSvg.append("g")
    .selectAll("g")
    .data(northeastStates)
    .enter()
    .append("g")
    .attr("class", "northeast-state-group");

  northeastStateGroups.append("rect")
    .attr("id", d => classify(d) + "-square")
    .attr("width", 15)
    .attr("height", 15)
    .attr("x", 730)
    .attr("y", (d, i) => 210 + 20 * i)
    .attr("fill", "#00ffff");
};

var renderGeoLabels = function(data, type) {
  d3.selectAll(".geo-northeast-labels").remove();
  var geoNortheastLabels = d3.selectAll(".northeast-state-group")
    .append("text")
    .attr("class", "geo-northeast-labels")
    .text(d => d + " ")
    .attr("font-size", isMobile.matches ? 18 : 12)
    .attr("x", 750)
    .attr("y", (d, i) => 223 + 20 * i);

  if (!isMobile.matches) {
    geoNortheastLabels.append("tspan")
      .text(d => {
        var electors = data.find(x => x.usps === d).electors;
        return electors;
      });
  }

  d3.selectAll(".geo-elector-labels").remove();
  data.forEach(d => {
    if (northeastStates.indexOf(d.usps) != -1) {
      return;
    } else {
      var stateGroup = geographicMapSvg.select("." + classify(d.usps)),
        bounds = stateGroup.select("path").node().getBBox(),
        text = stateGroup.select("text"),
        xOffset = d.geoX ? d.geoX : 0,
        yOffset = d.geoY ? d.geoY : 0;
      text.attr("text-anchor", "middle")
        .attr("font-size", isMobile.matches ? 22 : 13)
        .attr("fill", geoLabelColorExceptions.indexOf(d.usps) != -1 ? "#111111" : textColorScale(d[type + "_value"]))
        .attr("x", bounds.x + bounds.width / 2 + xOffset)
        .attr("y", () => {
          if (isMobile.matches) {
            return bounds.y + bounds.height / 2 + yOffset + 8;
          } else {
            return bounds.y + bounds.height / 2 + yOffset;
          }   
        });
      if (!isMobile.matches && ["NE-1", "NE-2", "NE-3", "NE-AL-A", "ME-1", "ME-2", "ME-AL-A"].indexOf(d.id) === -1) {
        text.append("tspan")
          .attr("class", "geo-elector-labels")
          .text(() => {
            if (d.usps === "NE") {
              return "5";
            } else if (d.usps === "ME") {
              return "4";
            } else {
              return d.electors;
            }
          })
          .attr("x", () => {
            if (horizontalStates.indexOf(d.usps) === -1) {
              return bounds.x + bounds.width / 2 + xOffset;
            }
          })
          .attr("y", () => {
            if (horizontalStates.indexOf(d.usps) === -1) {
              return bounds.y + bounds.height / 2 + yOffset + 15;
            }
          })
          .attr("dx", () => {
            if (horizontalStates.indexOf(d.usps) != -1) {
              return 4;
            }
          });
      }
    }
  })
};

var colorGeoMap = function(data, type) {
  data.forEach(d => {
    var stateEl = geographicMapEl.select("." + classify(d.usps));
    var stateShape = stateEl.select("path");
    
    // fill black if no data or data doesn't match any of the categories
    if (!d[type + "_value"] || !domain.includes(d[type + "_value"])) {
      stateShape.attr("fill", "#000");
    } else if (d.usps === "ME" || d.usps === "NE") {
      stateShape.attr("fill", "#e8e8e8");
      var el = geographicMapEl.select("." + classify(d.id));
      el.attr("fill", colorScale(d[type + "_value"]));
    } else if (northeastStates.indexOf(d.usps) != -1) {
      stateShape.attr("fill", colorScale(d[type + "_value"]));
      var el = geographicMapEl.select("#" + classify(d.usps) + "-square");
      el.attr("fill", colorScale(d[type + "_value"]));
    } else {
      stateShape.attr("fill", colorScale(d[type + "_value"]));
    }
  })
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);